import React, { useMemo } from 'react';
import { Segment } from 'tea-component';
import Sentiment from '@/pages/opinion/components/Snippets/Sentiment';
import Hot from '@/pages/opinion/assets/svg/hot-segment/hot.svg';
// 新增svg  Important Hot New Rising
import NewIcon from '@op/assets/svg/hot-segment/new.svg';
import RisingIcon from '@op/assets/svg/hot-segment/rising.svg';

import './index.scss';
import useLanguage from '@op/hooks/useLanguage';
import CardCommon from '@op/components/CardCommon';
import { NO_DATE } from '@op/constants';
import { getEventTitleText } from '@op/pages/Summary/utils';
import { useLocalLanguage } from '@op/utils/languageValue';
import SvgIcon from '@home/components/SvgIcon';
import { useToOpinionPage } from '../../utils';
import CommonBubble from '@home/components/CommonBubble';
export default function HotEvent({
  // getHotEvent,
  data,
  setValue,
  loading,
  value,
  filter,
}: {
  loading?: boolean;
  value: string;
  setValue: (value: string) => void;
  data: any;
  // getHotEvent: (params: any) => void;
  filter: any;
}) {
  const { language, formatMessage } = useLocalLanguage({
    languageType: 'origin',
  });

  const { formatOptionsMessage } = useLanguage();
  const height = 165;

  // const getRefreshNewTimeElement = () => {
  //   const { hot_event_has_data_time } = data || {};
  //   const { has_data_end_time, has_data_start_time } =
  //     hot_event_has_data_time || {};

  //   if (!has_data_end_time) return null;
  //   return (
  //     <Button
  //       type="link"
  //       style={{ paddingLeft: 5 }}
  //       onClick={() => {
  //         getHotEvent({
  //           start_time: moment(has_data_start_time).format(
  //             'YYYY-MM-DD hh:mm:ss',
  //           ),
  //           end_time: moment(has_data_end_time).format('YYYY-MM-DD hh:mm:ss'),
  //         });
  //       }}
  //     >
  //       {formatMessage({ id: 'Click to view recent event.' })}
  //     </Button>
  //   );
  // };

  function getShowIconInfo(data: any) {
    return [
      { key: 'rise_icon', icon: RisingIcon, tooltip: 'dbh_studio_hotevent_rese_tooltip' },
      { key: 'hot_icon', icon: Hot, tooltip: 'dbh_studio_hotevent_hot_tooltip' },
      { key: 'new_icon', icon: NewIcon, tooltip: 'dbh_studio_hotevent_new_tooltip' },
    ].map(({ key, icon, tooltip }) => (
      <React.Fragment key={key}>
        {data[key] === 1 && (
          <CommonBubble content={formatMessage({ id: tooltip })}>
            <img src={icon} className="dbh-studio-hotevent-img"></img>
          </CommonBubble>
        )}
      </React.Fragment>
    ));
  }

  const { tipsElement, empty, renderList, params, latestDateWithData } = useMemo(() => {
    const { hot_event_has_data_time, hot_events } = data || {};
    const {
      has_data_start_time: start_time,
      has_data_end_time: end_time,
      days,
      hint_tag,
    } = hot_event_has_data_time || {};
    let text: string = NO_DATE.SELECTION;
    // 本身有数据，但是展示无数据，就是过滤了所有的数据，所以展示这个情况
    if (value === 'all') {
      // hintTag !== “1”的情况
      if (hint_tag === '1') {
        text =
          'There is not enough data under the current filter to generate Hot Event.';
      } else {
        text = end_time
          ? 'Hot event is being generated.'
          : 'This game is not configured with NLP tasks, feel free to contact Miamgao if you need.';
      }
    }

    return {
      tipsElement: (
        <div style={{ textAlign: 'center' }}>
          <p>
            {formatMessage({ id: text })}
            {/* {value === 'all' && getRefreshNewTimeElement()} */}
          </p>
        </div>
      ),
      empty: !hot_events || hot_events?.length === 0,
      renderList: hot_events || [],
      params: { start_time, end_time, days },
      /** latestDateWithData 取 start_time 或 end_time 都没差，因为舆情后端已经确认，前端取 hot_event 必须传一天粒度 */
      latestDateWithData: (end_time || '').split(" ")[0],
    };
  }, [data, formatMessage]);

  const { goToOtherPage } = useToOpinionPage({
    filter,
    key: 'Hot Event',
    subKey: value,
    simple: true,
  });

  const canJump = !(loading || empty);
  function clickToPage() {
    canJump && goToOtherPage({ tab: value, ...params });
  }

  return (
    <div className="dbh-studio-hotevent">
      <div className="dbh-studio-hotevent-header">
        <div className="dbh-studio-hotevent-title" onClick={clickToPage}>
          {formatMessage({ id: 'Hot Event' })}
          {canJump && (
            <SvgIcon type="studio-arrow" className="dbh-trend-card-title-icon" />
          )}
        </div>
        <div className="dbh-studio-hotevent-tab">
          <Segment
            value={value}
            onChange={(value) => setValue(value)}
            options={formatOptionsMessage([
              { text: 'All', value: 'total' },
              { text: 'Social Media', value: 'social' },
              { text: 'Game Store', value: 'comments' },
            ])}
          />
        </div>
      </div>
      {(latestDateWithData && !loading && !empty) && (
        <div className='dbh-studio-hotevent-date'>{latestDateWithData}</div>
      )}
      <CardCommon
        contentCard
        loading={loading}
        loadingHeight={height}
        hasEmptyDesc={false}
        emptyDescElement={tipsElement}
        hasEmptyTitle={false}
        emptyHeight={height}
        empty={empty}
      >
        <div className="dbh-studio-hotevent-body" onClick={clickToPage}>
          <div className="dbh-studio-hotevent-list">
            {/* 列表标题 */}
            <div className="dbh-studio-hotevent-list-header">
              <span>{formatMessage({ id: 'Topics' })}</span>
              <span>{formatMessage({ id: 'Mentions' })}</span>
            </div>
            <div className="dbh-studio-hotevent-list-content">
              {/* 列表循环 */}
              {renderList.map((item: any) => (
                <div className="dbh-studio-hotevent-item" key={item.id}>
                  <div className="dbh-studio-hotevent-item-title">
                    <Sentiment
                      className="dbh-studio-hotevent-icon"
                      sentiment={item.avg_sentiment}
                      showValue={false}
                    ></Sentiment>
                    <span className="dbh-studio-hotevent-item-title-text">
                      {getEventTitleText(item, language)}
                    </span>
                    {getShowIconInfo(item)}
                  </div>
                  <div className="dbh-studio-hotevent-item-num">
                    <span>{item.mentions}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardCommon>
    </div>
  );
}
